// eslint-disable-next-line
const config = SMP_CONFIG

export const simpleServiceSortBy = SMP_CONFIG?.contextConfig?.extended?.featureConfig?.simpleServiceSortBy || 'name';
export const capacityId = SMP_CONFIG?.contextConfig?.extended?.featureConfig?.capacityId || null;
export const locationId = SMP_CONFIG?.contextConfig?.locationId;
export default config;
